import { AppMenuItem } from './app-menu-item';

export class AppMenu {
    name = '';
    displayName = '';
    items: AppMenuItem[];
    itemsNew: AppMenuItem[];

    constructor(name: string, displayName: string, items: AppMenuItem[], itemsNew?: AppMenuItem[]) {
        this.name = name;
        this.displayName = displayName;
        this.items = items;
        this.itemsNew != itemsNew;
    }
}
